import REQUEST_ASSET from "../../../../utilities/assets/REQUEST";
import {dateFormat} from "../../../../utilities/dateFormat";

export const makeStockPoolsTableData = stockPools =>
  stockPools
    ? stockPools.map((stockPool, index) => ({
        number: ++index,
        id: stockPool.stockPoolId,
        stockPoolNumber: stockPool.stockPoolNumber,
      }))
    : [];

export const makeStockPoolRqstsTableData = (requests, language) =>
  requests?.map((request, index) => {
    const Request = new REQUEST_ASSET(request, language);
    const bringTo = Request.bringToTableData;
    const country = Request.countryTableData;
    const managerCo = Request.managerCoTableData;
    const productGroup = Request.productGroupTableData;
    const logist = Request.logistTableData;
    const spNumber = Request.stockPool?.stockPoolNumber;

    return {
      number: ++index,
      id: request?.requestId ?? index,
      requestId: request?.requestId ?? null,
      // skuRequestId: skuRequestId ?? null,
      requestNumber: request?.requestNumber ?? " - ",
      factory: request?.factory?.name ?? " - ",
      requestSum: request?.requestSum ?? " - ",
      readinessDate: dateFormat((request?.requestDates ?? [])[0]?.actualDate) ?? " - ",
      productGroup,
      bringTo,
      productCountry: country,
      profCountry: (request?.proforms ?? [])[0]?.country?.shortName ?? "-",
      managerCo,
      logist,
      spNumber,
    };
  }) ?? [];
